import React from 'react'
import PropTypes from 'prop-types'
import FinancialAccountRow from './FinancialAccountRow'

const FinancialAccountHeader = (props) => {
  const {
    showMarketValue,
    accountNameLabel,

  } = props

  return (
    <FinancialAccountRow
      isHeaderRow={true}
      showMarketValue={showMarketValue}
      accountNameLabel={accountNameLabel} />
  )
}

FinancialAccountHeader.propTypes = {
  showMarketValue: PropTypes.bool.isRequired,
  accountNameLabel: PropTypes.string.isRequired
}

export default FinancialAccountHeader



// WEBPACK FOOTER //
// ./src/components/Client/FinancialAccountsList/FinancialAccountHeader.jsx